import { createContext } from 'react';

const DashboardScreenContext = createContext( null );

export default DashboardScreenContext;